import { DragObjectWithType } from 'react-dnd'

export interface ColumnOption {
  id: number | string
  label: string
  value?: string
  color?: string
  position: number
  _destroy?: boolean
}

export interface Column {
  id: number | string
  type: string
  key: string
  label: string
  position: number
  required?: boolean
  system_column?: boolean
  color?: string
  settings?: Record<string, unknown>
  column_options?: ColumnOption[]
  _destroy?: boolean
}

export interface ProjectGroupProps {
  id: number
  name: string
  columns: Column[]
  system_column_keys: string[]
  required_eligible_system_keys: string[]
}

export const ITEM_TYPE_COLUMN = 'PROJECT_GROUP_COLUMN'
export const ITEM_TYPE_OPTION = 'COLUMN_OPTION'

export interface SortableDragItem extends DragObjectWithType {
  id: number | string
  index: number
}
